import { Controller } from "@hotwired/stimulus";
import { flatpickrAltInput, isFlatpickrInput } from "../utils/date_utils";

export default class extends Controller {
  static classes = ["invalid"];

  checkValidation(event) {
    const input = event.currentTarget;
    const validations = input.dataset.validations;
    const inputValid = this.inputValid(input.value, validations);
    this.updateInput(input, inputValid);
  }

  inputValid(inputValue, validations) {
    return validations.includes("not-empty") && this.inputNotEmpty(inputValue);
  }

  updateInput(input, inputValid) {
    const displayedInput = isFlatpickrInput(input) ? flatpickrAltInput(input) : input;
    inputValid ? displayedInput.classList.remove(this.invalidClass) : displayedInput.classList.add(this.invalidClass);
  }

  inputNotEmpty(inputValue) {
    return String(inputValue).trim() !== "";
  }
}
